export const COOKIE_INTERVAL = 2000;
export const DELETE_COOKIE_DELAY = 3000;
export const VERIFY_ACCOUNT_COOKIE = 'verified';
